<template>
  <hr
    :class="{
      'mx-auto my-30px max-w-64 border-[2px] border-www-color-neutral-light': true,
    }"
  />
</template>

<script lang="ts" setup></script>

<style></style>
